import { Link } from 'react-router';
import { FileQuestion } from 'lucide-react';
import { Button } from '@/shared/components/Button';
import styles from './ErrorPage.module.css';

export function NotFoundPage() {
  return (
    <div className={styles.wrapper}>
      <FileQuestion size={64} strokeWidth={1.5} className={styles.icon} />
      <h1 className={styles.code}>404</h1>
      <p className={styles.title}>Página não encontrada</p>
      <p className={styles.description}>
        A página que você procura não existe ou foi movida.
      </p>
      <Link to="/">
        <Button variant="primary">Voltar ao início</Button>
      </Link>
    </div>
  );
}
